import { photoLabel } from "../settings/productLabel";

// The kiosk logs SocialPay and QPay payments in PaymentLog, and prints paid from a page
// bundle, whose amount is 0 (the bundle's money counts when it is sold); POS is kept
// for older records
export const PAYMENT_TYPES = [
  { value: "qpay", label: "QPay" },
  { value: "socialpay", label: "SocialPay" },
  { value: "bundle", label: "Багц" },
  { value: "POS", label: "POS" },
];

export const paymentTypeLabel = (value) =>
  (PAYMENT_TYPES.find((item) => item.value === value) || {}).label || value || "—";

// A payment's color_type as kiosks have sent it over the years: mono, -mono, MONO,
// colored, -color, -colored or COLOR (the cloud's utils/tenantReport.js reads it the
// same way)
export const isMono = (type) => /mono|black/i.test(String(type || ""));
export const isColor = (type) => /color/i.test(String(type || ""));

const colorLabel = (type) => {
  if (isMono(type)) return "Хар цагаан";
  if (isColor(type)) return "Өнгөт";
  return type || "—";
};

// A photo order. The kiosk charges it as colored pages, so its photo_type is what says
// it was photos or ID photos (the cloud's models/PaymentLog.js).
export const isPhoto = (item) => Boolean(item.photo_type);

// What a payment, or a row of payments summed by kind, was for
export const printLabel = (item) =>
  isPhoto(item) ? photoLabel(item.photo_type) : colorLabel(item.color_type);

// An invoice gets an unpaid row when it is made and a separate paid row when it is
// paid. QPay writes the unpaid row as "unpiad".
export const isPaid = (item) => item.payment_status === "paid";

// A refund saved before refund_amount existed has none and counts as the whole amount
export const refundedAmount = (item) =>
  item.refunded
    ? typeof item.refund_amount === "number"
      ? item.refund_amount
      : item.amount
    : 0;

// A print error refund can return only part of the payment; the refund button is always the whole of it
export const isPartialRefund = (item) =>
  item.refunded &&
  typeof item.refund_amount === "number" &&
  item.refund_amount > 0 &&
  item.refund_amount < item.amount;

// Pages the customer paid for: pages of one copy × copies (older rows have no copies)
export const totalPages = (item) => (item.pages || 0) * (item.copies || 1);

export const BADGES = {
  paid: {
    label: "Төлөгдсөн",
    badge: "text-green-700 bg-green-100 dark:bg-green-700 dark:text-green-100",
  },
  refunded: {
    label: "Буцаасан",
    badge: "text-red-700 bg-red-100 dark:bg-red-700 dark:text-red-100",
  },
  partial: {
    label: "Хэсэгчлэн буцаасан",
    badge: "text-blue-700 bg-blue-100 dark:bg-blue-700 dark:text-blue-100",
  },
  unpaid: {
    label: "Төлөгдөөгүй",
    badge: "text-yellow-700 bg-yellow-100 dark:bg-yellow-700 dark:text-yellow-100",
  },
  // The unpaid row of an invoice whose paid row is in the list too
  invoice: {
    label: "Нэхэмжлэх",
    badge: "text-gray-600 bg-gray-100 dark:bg-gray-700 dark:text-gray-300",
  },
};

export const badgeOf = (item, paidInvoices) => {
  if (isPaid(item)) {
    if (isPartialRefund(item)) return BADGES.partial;
    return item.refunded ? BADGES.refunded : BADGES.paid;
  }
  return item.invoice && paidInvoices.has(item.invoice)
    ? BADGES.invoice
    : BADGES.unpaid;
};
